<template>
  <el-table
    :data="scheduleReports"
    class="table-responsive table-striped"
    header-row-class-name="thead-light"
    style="width: 100%;"
  >
    <el-table-column label="Cliente"          min-width="300px" prop="schedule.client.razao_social" />
    <el-table-column label="Descrição"        min-width="300px" prop="schedule.note" />
    <el-table-column label="Início da Visita" min-width="220px" prop="schedule.date_start" >
      <template slot-scope="scope">
        {{ scope.row.schedule.date_start | formatDate('datetime') }}
      </template>
    </el-table-column>
    <el-table-column label="Fim da Visita" min-width="220px" prop="schedule.date_end">
      <template slot-scope="scope">
        {{ scope.row.schedule.date_end | formatDate('datetime') }}
      </template>
    </el-table-column>

    <el-table-column
      v-if="canEdit"
      label="Ações"
      width="80px"
      prop="acoes"
      v-slot="{ row }"
    >
      <el-dropdown
        class="dropdown"
        style="cursor: pointer;"
      >
        <span class="btn btn-sm btn-icon-only text-success">
          <i class="fas fa-ellipsis-v mt-2"></i>
        </span>
        <el-dropdown-menu
          class="dropdown-menu dropdown-menu-arrow show"
          slot="dropdown"
        >
          <a class="dropdown-item" href="#" @click.prevent.stop="$emit('action:edit', row)">Editar</a>
          <a class="dropdown-item" href="#" @click.prevent.stop="loadingExportPdf || $emit('action:export-pdf', row)" v-loading="loadingExportPdf" :disabled="loadingExportPdf" >Exportar PDF</a>
        </el-dropdown-menu>
      </el-dropdown>
    </el-table-column>
  </el-table>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  Dropdown,
} from "element-ui";

const ElTable = Table
const ElTableColumn = TableColumn
const ElDropdownMenu = DropdownMenu
const ElDropdown = Dropdown
const emit = defineEmits(["input", "search"]);


defineProps({
  scheduleReports: {
    type: Array,
    required: true,
    default: () => ([]),
  },
  loadingExportPdf: {
    type: Boolean,
    required: false,
    default: false,
  },
  canEdit: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>
